<ng-container *ngIf="imageUrls">
    <a class="pull-right close-btn" (click)="dismiss()"><i class="fa fa-close fa-2x icon"></i></a>
    <carousel>
        <slide *ngFor="let image of imageUrls">
            <img [src]="image" class="img-responsive">
        </slide>
    </carousel>
</ng-container>